var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n    "+_vm._s(_vm.prefix)+"\n    "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.citationHtml)}}),_vm._v(" "),(_vm.link)?_c('a',{attrs:{"href":_vm.link,"target":"_blank"}},[_vm._v("Visit Citation "),_c('font-awesome-icon',{attrs:{"icon":"external-link-alt"}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }